module.exports = __webpack_public_path__ + "static/media/43.f13121c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/43.wav
// module id = fDD/
// module chunks = 0